import { render, staticRenderFns } from "./VueForm.vue?vue&type=template&id=75a9001c&"
import script from "./VueForm.vue?vue&type=script&lang=js&"
export * from "./VueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports